export default __webpack_public_path__ + "static/media/qrcode_2.9d9c250c.png";